import(/* webpackMode: "eager" */ "/codebuild/output/src3195129928/src/actions-runner/_work/eon-service/eon-service/frontend/apps/eon/src/app/error.tsx");
